import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Button, Col, Row, Popover, message } from 'antd';
import './MultiFactor.css';
import { MdKeyboardBackspace } from 'react-icons/md';
import Index from '../Index';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import QRCode from 'qrcode.react';
import VerificationInput from 'react-verification-input';
import { QrgeneratorActionHandler } from '../../Redux/Actions/user/SettingsOrGenerator';
import { QrCodeVerifyActionHandler } from '../../Redux/Actions/user/SettingsOrCodeVerify';
import { RiCoinsLine } from 'react-icons/ri';

const MultiFactor = () => {
    const mainLogo = '/assets/QA_Logo.svg';
    const dispatch = useDispatch();
    let Navigate = useNavigate();
    const targetRef = useRef();
    const [qrCodeData, setQrCodeData] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [mfa, setMfa] = useState();
    const [isEnabled, setIsEnabled] = useState(true);
    const [isGeneratQr, setIsGeneratQr] = useState(false);
    const [api, contextHolder] = notification.useNotification();
    const [verificationValue, setVerificationValue] = useState('');
    const [isVerificationCodeOpen, setIsVerificationCodeOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const userProfileData = useSelector(
        (state) => state.SettingsUserProfileData
    );
    const CodeData = useSelector(
        (state) => state?.SettingsOrGeneratorData?.mfasettings_data?.data?.code
    );
    const qrVerifyCodeData = useSelector(
        (state) => state?.SettingsCodeVerifyData
    );
    const [updateValue, setUpdateValue] = useState(
        userProfileData?.user_profile_data?.is_mfa_enabled
    );

    useEffect(() => {
        dispatch(QrgeneratorActionHandler());
    }, []);

    useEffect(() => {
        const client_mfa_enabled = JSON.parse(
            localStorage.getItem('client_mfa_enabled')
        );
        // dispatch(QrgeneratorActionHandler());
        // if (client_mfa_enabled === false) {
        //     Navigate("/")
        // }
        qrVerifyCodeData &&
            setMfa(
                qrVerifyCodeData?.qrVerifyCodeMessage?.data?.user
                    ?.is_mfa_enabled
            );
    }, [qrVerifyCodeData]);

    useEffect(() => {
        setIsEnabled(false);
        setIsGeneratQr(false);
        if (CodeData) {
            const userDetails = JSON.parse(localStorage.getItem('userDetails'));
            const appName = process.env.REACT_APP_NAME || 'QuickAction';
            const generatedQrCodeData = `otpauth://totp/${encodeURIComponent(
                appName
            )}:${encodeURIComponent(
                userDetails.email
            )}?secret=${encodeURIComponent(
                CodeData
            )}&issuer=${encodeURIComponent(appName)}`;
            setQrCodeData(generatedQrCodeData);
        }
    }, [CodeData]);
    const handleCopyClick = () => {
        const chatScreenContent = targetRef.current.innerText;
        if (chatScreenContent.trim() === '') {
            message.error('No text/Data to copy');
            return;
        }
        navigator.clipboard
            .writeText(chatScreenContent)
            .then(() => {
                setIsCopied(true);
                message.success('Copied to clipboard');
            })
            .catch((error) => {
                console.error('Error copying chat screen:', error);
                message.error('Error copying chat screen');
            });
    };
    const handleCodeText = () => {
        setVerificationValue('');
        setQrCodeData(!qrCodeData);
        setIsVerificationCodeOpen(!isVerificationCodeOpen);
    };
    const handleStatus = (values) => {
        dispatch(QrgeneratorActionHandler());
        setQrCodeData(false);
        setIsVerificationCodeOpen(false);
    };
    const validateInput = () => {
        if (!verificationValue.trim()) {
            setErrorMessage('This field cannot be empty.');
            return false;
        }
        return true;
    };
    const handleVerificationChange = (value) => {
        setVerificationValue(value);
        if (errorMessage) setErrorMessage('');
    };

    const onVerifyCodeFinish = () => {
        // event.preventDefault();
        const isValid = validateInput();
        if (!isValid) return;
        try {
            dispatch(
                QrCodeVerifyActionHandler(verificationValue, (error, data) => {
                    if (error) {
                        console.error('Error during verification:', error);
                        return;
                    }
                    Navigate('/');
                })
            );
        } catch (error) {
            console.error('Error during verification:', error);
        }
    };
    const content = (
        <div>
            <h4>Can't scan image?</h4>
            <p>Enter the following into your app: </p>
            Code : &nbsp;
            <div className='popover bold'>
                <span ref={targetRef}>{CodeData}</span>{' '}
                <img
                    src='/images/copy.svg'
                    className='output-img'
                    alt=''
                    onClick={handleCopyClick}
                />
            </div>
        </div>
    );
    const logo = 'assets/QA_Logo.svg';
    const desktop = 'assets/logo.svg';
    return (
        <>
            <Row>
                <Col span={12} className='data-align'>
                    <div className='img'>
                        <img src={desktop} className='desktop-img' alt='' />
                    </div>
                </Col>
                <Col span={12}>
                    <div className='container data-align'>
                        <div className='main'>
                            <img src={logo} className='logo-img' alt='' />
                            <div className='inner-div'>
                                <div className='inner-textdiv1'>
                                    Continue with Multi Factor Authentication
                                </div>
                            </div>
                            {!isVerificationCodeOpen ? (
                                <>
                                    <div className='inner-small'>
                                        Scan this QR code with your verification
                                        app
                                    </div>
                                    <div className='mfa-settings-qrcode'>
                                        <QRCode value={qrCodeData} />
                                    </div>
                                    <p className='inner-small'>
                                        Can’t scan the code?{' '}
                                        <Popover
                                            content={content}
                                            title='Title'
                                            trigger='click'
                                            className='click-me'>
                                            <Button>Click me</Button>
                                        </Popover>
                                    </p>
                                    <Button
                                        onClick={handleCodeText}
                                        htmlType='submit'
                                        className='submit_verify-btn'>
                                        Next
                                    </Button>
                                </>
                            ) : (
                                <div className='mfa-settings-main'>
                                    <Form
                                        name='verification'
                                        initialValues={{ code: '' }}
                                        onFinish={onVerifyCodeFinish}>
                                        <div className='Verification_input'>
                                            <label>
                                                Enter your verification code to
                                                continue.
                                            </label>
                                            <VerificationInput
                                                validChars='0-9'
                                                value={verificationValue}
                                                onChange={
                                                    handleVerificationChange
                                                }
                                            />
                                            {errorMessage && (
                                                <p style={{ color: 'red' }}>
                                                    {errorMessage}
                                                </p>
                                            )}
                                        </div>
                                        <Form.Item>
                                            <Button
                                                type='primary'
                                                htmlType='submit'
                                                block
                                                className='submit_verify-btn mfa-settings-marginTop-30'
                                                // onClick={handleStatusUpdate}
                                            >
                                                Verify and Login
                                            </Button>
                                            <h4
                                                className='back verify'
                                                onClick={handleStatus}>
                                                <MdKeyboardBackspace />
                                                Back
                                            </h4>
                                        </Form.Item>
                                    </Form>
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default MultiFactor;
